var _defs, _path, _rect, _circle, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _polygon2, _polygon3, _polygon4, _polygon5, _a, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCisaBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 375 375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #e31837;\n      }\n\n      .cls-5 {\n        fill: #1d2d5c;\n      }\n\n      .cls-3 {\n        stroke: #1d2d5c;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m192.79,9.31v-.06H12.41v173.53c-.01.82-.03,1.64-.03,2.47s.02,1.65.03,2.47v1.91h.02c2.33,95.18,80.21,171.62,175.94,171.62s176-78.8,176-176S287.96,11.65,192.79,9.31Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.24,
    y: 27.99,
    width: 37.07,
    height: 37.07
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 188.38,
    cy: 185.26,
    r: 152.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "60.75 56.11 58.29 53.11 55.82 56.11 55.82 37.5 60.75 37.5 60.75 56.11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "logoMark_CompoundPathItem_",
    "data-name": "logoMark &lt;CompoundPathItem&gt;",
    className: "cls-5",
    d: "m294.41,205.23c2.1,0,3.82,1.72,3.82,3.82s-1.72,3.81-3.82,3.81-3.81-1.71-3.81-3.81,1.71-3.82,3.81-3.82Zm0,7c1.76,0,3.17-1.42,3.17-3.17s-1.41-3.17-3.17-3.17-3.17,1.41-3.17,3.17,1.42,3.17,3.17,3.17Zm-1.33-4.93c0-.11.08-.2.2-.2h1.51c.66,0,1.31.39,1.31,1.19s-.56,1.08-.86,1.16c.21.41.42.84.64,1.25.07.13-.03.29-.18.29h-.36c-.08,0-.16-.08-.19-.15l-.59-1.33h-.79v1.27c0,.11-.08.2-.2.2h-.28c-.12,0-.2-.1-.2-.2v-3.48Zm1.71,1.59c.39,0,.64-.28.64-.61,0-.36-.24-.6-.64-.6h-1.04v1.21h1.04Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "logoMark_CompoundPathItem_-2",
    "data-name": "logoMark &lt;CompoundPathItem&gt;",
    className: "cls-5",
    d: "m148.93,157.27c7.63,0,13.27,2.37,18.46,7.1.69.61.69,1.53.08,2.14l-5.95,6.18c-.53.53-1.37.53-1.91,0-2.82-2.52-6.56-3.89-10.3-3.89-8.62,0-14.95,7.17-14.95,15.72s6.41,15.49,15.03,15.49c3.59,0,7.48-1.3,10.22-3.66.53-.46,1.53-.46,1.98.08l5.95,6.33c.53.53.46,1.53-.08,2.06-5.19,5.04-11.75,7.4-18.54,7.4-15.26,0-27.54-12.13-27.54-27.39s12.28-27.54,27.54-27.54Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "logoMark_CompoundPathItem_-3",
    "data-name": "logoMark &lt;CompoundPathItem&gt;",
    className: "cls-5",
    d: "m176.63,159.49c0-.76.69-1.45,1.45-1.45h9.15c.76,0,1.45.69,1.45,1.45v50.5c0,.76-.69,1.45-1.45,1.45h-9.15c-.76,0-1.45-.69-1.45-1.45v-50.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "logoMark_CompoundPathItem_-4",
    "data-name": "logoMark &lt;CompoundPathItem&gt;",
    className: "cls-5",
    d: "m198.75,204.19l3.59-6.33c.61-.99,2.06-.84,2.59-.46.31.15,5.8,4.2,10.83,4.2,3.05,0,5.26-1.91,5.26-4.58,0-3.2-2.67-5.65-7.86-7.71-6.56-2.59-14.8-7.71-14.8-16.86,0-7.55,5.87-15.18,17.62-15.18,7.93,0,14.04,4.04,16.33,5.72.92.53.76,1.91.46,2.44l-3.89,5.87c-.53.84-1.91,1.53-2.59.99-.69-.38-6.26-4.58-10.91-4.58-2.75,0-4.81,1.83-4.81,3.89,0,2.82,2.29,4.96,8.32,7.4,5.95,2.37,15.41,7.02,15.41,17.39,0,7.86-6.79,15.79-18,15.79-9.92,0-15.41-4.12-17.17-5.87-.76-.76-.99-1.07-.38-2.14Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "logoMark_CompoundPathItem_-5",
    "data-name": "logoMark &lt;CompoundPathItem&gt;",
    className: "cls-5",
    d: "m236.74,209.46l23.88-51.34c.23-.46.76-.84,1.3-.84h.76c.53,0,1.07.38,1.3.84l23.88,51.34c.46.99-.15,1.98-1.3,1.98h-8.47c-1.37,0-1.98-.46-2.67-1.91l-2.75-6.03h-20.75l-2.75,6.1c-.38.92-1.22,1.83-2.75,1.83h-8.39c-1.14,0-1.75-.99-1.3-1.98Zm31.36-16.33l-5.8-12.59h-.08l-5.72,12.59h11.6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.75,34.56v23.94h-23.94v-23.94h23.94m2-2h-27.94v27.94h27.94v-27.94h0Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "48.84 37.5 42.05 37.5 42.05 39.54 48.84 39.54 48.84 37.5 48.84 37.5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "49.96 44.49 42.05 44.49 42.05 46.53 49.96 46.53 49.96 44.49 49.96 44.49"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "52.38 49.51 42.05 49.51 42.05 51.56 52.38 51.56 52.38 49.51 52.38 49.51"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "50.8 54.07 42.05 54.07 42.05 56.11 50.8 56.11 50.8 54.07 50.8 54.07"
  })), _a || (_a = /*#__PURE__*/React.createElement("a", {
    xlinkHref: 65.3996078431373
  }, /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_",
    "data-name": "logoMark &lt;PathItem&gt;",
    className: "cls-4",
    d: "m186.33,271.09c-49.38,0-89.15-41.91-85.61-92.02,3.01-42.6,37.75-76.94,80.38-79.48,36.67-2.19,68.79,18.81,83.11,49.68.35.74,1.08,1.23,1.9,1.23h19.24c1.46,0,2.51-1.46,2-2.83-15.46-41.52-55.75-70.95-102.84-70.18-56.81.93-103.74,46.8-105.91,103.57-2.34,61.46,46.78,112.02,107.72,112.02,46.27,0,85.7-29.16,100.99-70.09.51-1.37-.53-2.84-2-2.84h-19.25c-.82,0-1.55.48-1.9,1.22-13.66,29.34-43.4,49.74-77.84,49.74Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 375,
    height: 375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCisaBadge);
export default __webpack_public_path__ + "static/media/cisa-badge.2b409aa8332d44732b72b52fbfcb885f.svg";
export { ForwardRef as ReactComponent };